import { Component, OnDestroy, OnInit } from '@angular/core';
declare function setApiUrlsForEnrollment(a: any): any;
declare function getChatbotIdForEnrollmentBot(): any;
declare function getValidAccessToken(): any;
import { environment } from 'src/environments/environment';
import { AssetsPath } from 'src/static-assets/assets-path';

@Component({
  selector: 'app-chatbot',
  templateUrl: './chatbot.component.html',
  styleUrls: ['./chatbot.component.scss']
})
export class ChatbotComponent implements OnInit, OnDestroy {

  isChecked:boolean = false;
  welcomeAcknowledgePage = true;
  acknowledgeDocument = false;
  userAcknowledgementStatus = false;
  public isVisible: boolean = false;
  public showDiv: boolean = true;
  public isChatbotOpen: boolean = false;
  public isMaximizeFromSalesforceUser: boolean = false;
  public assetsPath = AssetsPath;
  public isMaximized: boolean = false;
  public dataFromSalesforce: any = {};
  private messageHandler: (event: MessageEvent) => void;
  public showAcknowledge = false;
  chatbotId: string = "";
  acknowledgmentVerified: string = 'false';
  loadChatbot: boolean = false;
  public categoryList:any[] = [];
  public selectedCategory: any = '';
  public isFaqConfigurationEnable: any = environment.faqConfigurationEnable;
  public showChatFAQs=[];
  public degreeCategoryList: any[] = ['Bachelor', 'Master', 'Doctoral', 'Education Specialist', 'Certificate'];
  public selectedDegreeCategory: any = '';
  public isDegreeCategorySelected: boolean = false;
  public FAQs = [];
  public isNewSession: boolean = false;
  public isLoading: boolean = true;

  constructor() { }

  ngOnInit() {
    setApiUrlsForEnrollment(environment.enrollmentConfig);
    this.toggleVisibility();
    this.acknowledgmentVerified = sessionStorage.getItem('salesforceuserack');
    this.checkAcknowledge();
    this.checkMsgFromSalesforce();
  }

  checkMsgFromSalesforce() {
    if (!this.messageHandler) {
      this.messageHandler = this.receiveMessageFromSalesforce.bind(this);    
      window.addEventListener('message', this.messageHandler.bind(this), false);
    }
  }

  async checkAcknowledge() {
    // var getResult = localStorage.getItem('salesforceuserack');
    // console.log('getResult: ', getResult);
    // if(getResult) {
    //   this.userAcknowledgementStatus = true;
    //   this.welcomeAcknowledgePage = false;
    // } else {
    //   this.userAcknowledgementStatus = false;
    // }
    this.chatbotId = await getChatbotIdForEnrollmentBot();
    this.chatbotId = sessionStorage.getItem('chatbotIdEnr');
    if ((this.chatbotId || this.chatbotId == null) && this.acknowledgmentVerified !== 'true' || this.acknowledgmentVerified == null) {
      const user_email = sessionStorage.getItem('userEmail');
  const mode = 'get';
  this.sendAcknowledgement(this.chatbotId, user_email, mode);
  }else if (this.acknowledgmentVerified == 'true') {
    this.showAcknowledge = false; 
    this.userAcknowledgementStatus = true;
    this.welcomeAcknowledgePage = false;
  }
    
  }

  acknowledgeRead(){
    this.welcomeAcknowledgePage = false;
    this.acknowledgeDocument = true;
    this.showAcknowledge= !this.showAcknowledge;
  }

  userAcknowledged(){
   // console.log('is checked: ', isChecked);
    this.acknowledgeDocument = false;
    const user_email = sessionStorage.getItem('userEmail');
    console.log('userEmail: ', user_email);
    const mode = 'set';
    this.sendAcknowledgement(this.chatbotId, user_email, mode);
    // localStorage.setItem('salesforceuserack', this.userAcknowledgementStatus.toString());
  }

  fadeInFadeOut() {
    this.showDiv = !this.showDiv;
  }

  maximizeChat() {
    // const chatPopup = document.querySelector('.hk-chatbot-popup');
    // if (chatPopup.classList.contains('maximized')) {
    //   chatPopup.classList.remove('maximized');
    // } else {
    //   chatPopup.classList.add('maximized');
    // }
   this.isMaximizeFromSalesforceUser = !this.isMaximizeFromSalesforceUser;
  // this.isMaximized = !this.isMaximized;
    if (this.isMaximizeFromSalesforceUser) {
      this.sendMsgToSalesforceForMaximize();
    } else {
      this.sendMsgSalesforceForGoBackToOriginal();
    }
  }

  public toggleVisibility() {
    console.log('toddle function');
    this.isVisible = !this.isVisible;
    //this.sendMessageToSalesforceForMinimizeChatbot();
}

// public FAQs = [
//   {category:"Walden General",query:"Does Walden offer job placement?"},
//   {category:"Walden General",query:"Does Walden offer tutoring?"},
//   {category:"Walden General",query:"Why should I choose Walden?"},
//   {category:"Walden General",query:"What does fafsa stand for?"},
//   {category:"Walden General",query:"What does degree acceleration mean?"},
//   {category:"Walden General",query:"Where is Walden located?"},
//   {category:"Nursing",query:"What is BSN Aim?"},
//   {category:"Nursing",query:"What is the GPA needed to enter into the bsn?"},
//   {category:"Nursing",query:"What are the concentrations for the bs in health studies?"},
//   {category:"Doctorate",query:"Is the PHD in management program accredited?"},
//   {category:"Doctorate",query:"What kind of jobs can someone with a phd in psychology get?"},
//   {category:"Doctorate",query:"What is difference between PHD & Doctorate?"},
// ]

applyFAQsSelection(event: Event){
  const selectElement = event.target as HTMLSelectElement;
  this.selectedCategory = selectElement.value;
  // var applyFAQ = document.getElementById("applyFaq");
  // console.log('applyFAQ: ', applyFAQ);
  // applyFAQ.style.backgroundColor = "#C4C4C4";
  // var selectElement = document.getElementById("categorySelect") as HTMLSelectElement;
  // var selectedOption = selectElement.options[selectElement.selectedIndex].value;
  if (this.isFaqConfigurationEnable) {
  if(this.categoryList.length > 0){
    this.showChatFAQs=[];
    this.categoryList.forEach((FAQ)=>{
      if(this.selectedCategory === FAQ.category){
        this.showChatFAQs.push(...FAQ.queries);
      }
    });
    // applyFAQ.style.backgroundColor = "#FDB71A";
  }
} else {
  this.FAQs.forEach((FAQ)=>{
    
      this.showChatFAQs.push(...FAQ.queries);
    
});
}
  
}

sendMessageToSalesforceForMinimizeChatbot() {
  const message = { function: 'CLOSE_CHATBOT' };
  console.log('enrollmentConfig.salesforceConfig.url: ', environment.enrollmentConfig.salesforceConfigUrl);
  window.parent.postMessage(message, environment.enrollmentConfig.salesforceConfigUrl);
}

receiveMessageFromSalesforce(event: MessageEvent) {
  console.log('event from ES: ', event);
  // if (event.origin !== environment.enrollmentConfig.salesforceConfigUrl) {
  //   return;
  // }
  const data = event.data;
  console.log('Message from origin Angular:', event.origin);
  if (!data || typeof data !== 'object') {
    console.log('Invalid data received:', data);
    return;
  }
  switch (data.function) {
    case 'ORIGINAL_CHATBOT_SIZE':
      this.sendMsgSalesforceForGoBackToOriginal();
      //this.isMaximizeFromSalesforceUser = !this.isMaximizeFromSalesforceUser;
      break;

    case 'ON_LOAD_SALESFORCE_DATA':
      this.isLoading = true;
      // Ensure user_data and required properties are present
      if (data.user_data && data.user_data.email && data.user_data.last_name && data.user_data.first_name) {
        console.log('user data: ', data.user_data);
        sessionStorage.setItem('userName', `${data.user_data.last_name}, ${data.user_data.first_name}`);
        sessionStorage.setItem('userEmail', data.user_data.email);
        sessionStorage.setItem('opportunityId', data.opportunityId);
        localStorage.setItem('userDataForOpp', this.generateUUID());    
        this.checkAcknowledge();
      } else {
        console.log('Incomplete user_data:', data.user_data);
      }
      break;
      case 'OPPORTUNITY_ID':
      console.log('data.opportunityId: ', data.opportunityId);
      sessionStorage.setItem('opportunityId', data.opportunityId);
          localStorage.setItem('userDataForOpp', this.generateUUID());
          
          // const responseClass = document.getElementsByClassName('list-unstyled')[0];
          // if (responseClass) {
          //   responseClass.classList.add('d-none');
          // }
          // pendingFeedbackForNewOpportunitySession();
          // refreshChatEnrollmentChatbotForNewOpportunity();
          // inputTextStatus(true);
         
          
      break;
    default:
      console.log('Unhandled function:', data.function);
  }
}

sendMsgToSalesforceForMaximize() {
  this.isMaximized = !this.isMaximized;
  const message = { function: 'MAXIMIZE_CHATBOT_SIZE' };
  var getChatbotBody = document.getElementById('chatbot-body');
  getChatbotBody.style.height = 78 + 'vh';
 // console.log('enrollmentConfig.salesforceConfig.url: ', environment.enrollmentConfig.salesforceConfigUrl);
  window.parent.postMessage(message, environment.enrollmentConfig.salesforceConfigUrl);
}

sendMsgSalesforceForGoBackToOriginal() {
  console.log('call the original size');
  this.isMaximized = !this.isMaximized;
  this.isMaximizeFromSalesforceUser = false;
  var getChatbotBody = document.getElementById('chatbot-body');
  getChatbotBody.style.height = 80 + 'vh';
  const message = { function: 'ORIGINAL_CHATBOT_SIZE'};
  window.parent.postMessage(message, environment.enrollmentConfig.salesforceConfigUrl);
}

async sendAcknowledgement(chatbotId: string, userEmail: string, mode): Promise<void> {
  const body = new URLSearchParams();
  body.set('user_email', userEmail);
  body.set('mode', mode);
  body.set('chatbot_id', chatbotId);
  const headers = {
    "Content-Type": "application/x-www-form-urlencoded",
  };
  const subscriptionKey = environment.enrollmentConfig.apimSubscriptionKeyForEnr;
  const token = await getValidAccessToken();
  if (environment.apimConfigurationEnable) {
    headers['Ocp-Apim-Subscription-Key'] = subscriptionKey;
    headers['AuthenticationType'] = 'Application';
    headers['Authorization'] = 'Bearer ' + token;
  }

  const response = await fetch(environment.commonConfig.acknowledgementAPI, {
    method: 'POST',
    headers: headers,
    body: body,
  });

  if (response.ok) {
    const responseData = await response.json();
    let acknowledgedStatus = responseData['Acknowledgement Status'];
    if (acknowledgedStatus === 'Not Found') {
      this.showAcknowledge = false; 
      this.userAcknowledgementStatus = false;
      this.welcomeAcknowledgePage = true;
      sessionStorage.setItem('acknowledgementVerified', 'false');
      
    } else if (acknowledgedStatus == 'yes'){
      this.showAcknowledge = false; 
      this.userAcknowledgementStatus = true;
      this.welcomeAcknowledgePage = false;
      sessionStorage.setItem('acknowledgementVerified', 'true');
      //this.acknowledged = true;
      
    } else if (acknowledgedStatus == 'Success'){
     this.showAcknowledge = false;
     this.userAcknowledgementStatus = true;
      this.welcomeAcknowledgePage = false;
     sessionStorage.setItem('acknowledgementVerified', 'true');
     localStorage.setItem('salesforceuserack', this.userAcknowledgementStatus.toString());
    //  this.disabledButton = true;
    
    }
    this.loadChatbot = true;
    this.isLoading = false;
  } else {
    console.error('API error:', response.statusText);
  }
}

ngOnDestroy(): void {
  if (this.messageHandler) {
    window.removeEventListener('message', this.messageHandler, false);
    this.messageHandler = null;
}
}

async getCategoryList(selectedDegreeCategory) {
  this.selectedCategory = 'Choose Category';
  this.categoryList = [];
  this.showChatFAQs = [];
  const body = JSON.stringify({
    chatbot_id: environment.enrollmentConfig.chatBotIdEnr,
    Level: selectedDegreeCategory,
    user_email: sessionStorage.getItem('userEmail')
  });
  let headers = {
    'Content-Type': 'application/json',
  }
  const subscriptionKey = environment.enrollmentConfig.apimSubscriptionKeyForEnr;
  const token = await getValidAccessToken();
  if (environment.apimConfigurationEnable) {
    headers['Ocp-Apim-Subscription-Key'] = subscriptionKey;
    headers['AuthenticationType'] = 'Application';
    headers['Authorization'] = 'Bearer ' + token;
  }
  const response = await fetch(environment.commonConfig.faqApi, {
    method: 'POST',
    headers: headers,
    body: body,
  });
  
  if(response.ok) {
    const responseData = await response.json();
    // this.selectedCategory = responseData.categories[0].category;
    this.categoryList = responseData.categories;
    this.selectedCategory = '';
    this.showChatFAQs = [];
    this.applyFAQsSelection(this.selectedCategory);
  }
  

}

applyDegreeSelection(event: Event) {
  const selectElement = event.target as HTMLSelectElement;
  this.selectedDegreeCategory = selectElement.value;
  this.isDegreeCategorySelected = true;
  this.getCategoryList(this.selectedDegreeCategory);
}

onclickFAQ(selectedDegreeCategory) {
  this.isDegreeCategorySelected = true;
  this.getCategoryList(selectedDegreeCategory);
}

// Function to generate a UUID
generateUUID() {
	const uuid = this.generateRandomUUID();
	return uuid;
}

// Generate a random UUID
generateRandomUUID() {
	return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
		const r = Math.random() * 16 | 0;
		const v = c == 'x' ? r : (r & 0x3 | 0x8);
		return v.toString(16);
	});
}

}
